import { render, staticRenderFns } from "./PresetBlocks.vue?vue&type=template&id=0134401e&"
import script from "./PresetBlocks.vue?vue&type=script&lang=ts&"
export * from "./PresetBlocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports